import { StateCardRoot } from "./StateCard";
import { StateCardIcon } from "./StateCardIcon";
import { StateCardTitle } from "./StateCardTitle";
import { StateCardDescription } from "./StateCardDescription";
import { StateCardAction } from "./StateCardAction";

export const StateCard = Object.assign(StateCardRoot, {
  Icon: StateCardIcon,
  Title: StateCardTitle,
  Description: StateCardDescription,
  Action: StateCardAction,
});

export type {
  StateCardProps,
  StateCardIconProps,
  StateCardTitleProps,
  StateCardDescriptionProps,
  StateCardActionProps,
  StateCardVariant,
} from "./types";
